var __webpack_exports__ = {};
/*!**********************************!*\
  !*** ./src/js/cart-gift-card.js ***!
  \**********************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initCartGiftCard = function initCartGiftCard() {
  var cartItem = document.querySelectorAll(".cart-item");
  initPersonalizeGiftCard();
  cartItem.forEach(function (cartItem) {
    cartItem.addEventListener("change", function (event) {
      if (event.target.classList.contains("personalize-toggle")) {
        toggleForm(cartItem);
      }
      if (event.target.classList.contains("radio")) {
        togglePersonalization(cartItem);
      }
    });
  });
};
var errorMessages = {
  email: "",
  from: "",
  name: ""
};
var togglePersonalization = function togglePersonalization(cartItem) {
  cartItem.querySelector(".personalize-input-wrapper").classList.toggle("hide");
  cartItem.querySelector(".personalize-toggle").disabled = cartItem.querySelector(".personalize-toggle").disabled ? false : true;
  if (cartItem.nextElementSibling.classList.contains("open")) {
    cartItem.nextElementSibling.classList.toggle("open");
  }
};
var toggleForm = function toggleForm(cartItem) {
  cartItem.nextElementSibling.classList.toggle("open");
};
var initPersonalizeGiftCard = function initPersonalizeGiftCard() {
  var lineItems = document.querySelectorAll(".gift-card-custom");
  lineItems.forEach(function (lineValue) {
    lineValue.querySelector(".cart-line-item-update").onclick = function (e) {
      e.preventDefault();
      lineValue.querySelector(".personalize-success").classList.add("hide");
      getNewInformations(lineValue);
    };
  });
  function getNewInformations(lineValue) {
    var line = lineValue.querySelector(".cart-line-item-update").dataset.index;
    var emailTo = lineValue.querySelector(".gift-card-custom__info--email-to");
    var from = lineValue.querySelector(".gift-card-custom__info--from");
    var nameTo = lineValue.querySelector(".gift-card-custom__info--name-to");
    var message = lineValue.querySelector(".gift-card-custom__info--message");
    var image = lineValue.querySelector('.image-choice input[type="radio"]:checked');
    var language = document.documentElement.lang.toLowerCase();
    if (!validateEmail(emailTo.value)) {
      var _language = document.documentElement.lang.toLowerCase();
      clearErrorMessages(lineValue);
      showError(lineValue, [getValidationErrors(emailTo.value, from.value, nameTo.value, _language)[0]]);
      return;
    }
    if (emailTo.value && from.value && nameTo.value && image) {
      var _properties;
      var propertyMappings = {
        "Recipient name": "À / To ",
        "Recipient email": "Courriel / Email ",
        From: "De / From "
      };
      var formData = {
        line: line,
        properties: (_properties = {
          __shopify_send_gift_card_to_recipient: "if_present",
          "Recipient email": emailTo.value
        }, _defineProperty(_properties, propertyMappings["Recipient name"], nameTo.value), _defineProperty(_properties, propertyMappings["From"], from.value), _defineProperty(_properties, "Message", message.value), _defineProperty(_properties, "__Image", image.dataset.image), _defineProperty(_properties, "__Date", new Date().toLocaleDateString()), _defineProperty(_properties, "__variant_id", lineValue.dataset.productId), _properties)
      };
      updateInformations(formData, lineValue);
    } else {
      clearErrorMessages(lineValue);
      showError(lineValue, getValidationErrors(emailTo.value, from.value, nameTo.value, language));
    }
  }
};
function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}
function updateInformations(formData, lineValue) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(function (response) {
    return response.json();
  }).then(function (response) {
    lineValue.querySelector(".personalize-success").classList.remove("hide");
    clearErrorMessages(lineValue);
  }).catch(function (error) {
    console.error("Error:", error);
  });
}
function clearErrorMessages(lineValue) {
  var errorInputs = lineValue.querySelectorAll(".error-input");
  errorInputs.forEach(function (input) {
    input.classList.remove("error-input");
  });
  var errorSpans = lineValue.querySelectorAll("span.error");
  errorSpans.forEach(function (span) {
    span.remove();
  });
}
function getValidationErrors(email, from, name, lang) {
  var errors = [];
  errorMessages.email = lang === "fr" ? "Veuillez saisir une adresse courriel valide" : "Please enter a valid email address";
  errorMessages.from = lang === "fr" ? "Veuillez saisir le nom de la personne qui offre la carte-cadeau" : "Please enter the name of the gift card giver";
  errorMessages.name = lang === "fr" ? "Veuillez saisir le nom de la personne qui recevra la carte-cadeau" : "Please enter the name of the gift recipient";
  if (!validateEmail(email)) errors.push(errorMessages.email);
  if (!from) errors.push(errorMessages.from);
  if (!name) errors.push(errorMessages.name);
  return errors;
}
function showError(lineValue, errors, lang) {
  errors.forEach(function (error) {
    var errorMessage = document.createElement("span");
    errorMessage.classList.add("error");
    errorMessage.innerHTML = error;
    var relatedInput;
    var parentDiv;
    switch (error) {
      case errorMessages.email:
        relatedInput = lineValue.querySelector(".gift-card-custom__info--email-to");
        parentDiv = relatedInput.closest(".input-label-left");
        break;
      case errorMessages.from:
        relatedInput = lineValue.querySelector(".gift-card-custom__info--from");
        parentDiv = relatedInput.closest(".input-label-left");
        break;
      case errorMessages.name:
        relatedInput = lineValue.querySelector(".gift-card-custom__info--name-to");
        parentDiv = relatedInput.closest(".input-label-left");
        break;
    }
    if (relatedInput) relatedInput.classList.add("error-input");
    if (parentDiv) parentDiv.parentNode.insertBefore(errorMessage, parentDiv.nextSibling);
  });
}
window.addEventListener("load", initCartGiftCard);
